import React, { useState, useEffect, useRef } from 'react';
import back_arrow from "../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import Contracts_header from "../Component/Header/Contracts_header";
import split from "../assets/svg/split.svg";
import sales from "../assets/svg/sales.svg";
import cost from "../assets/svg/cost.svg";
import split_hover from "../assets/svg/split-b.svg";
import sales_hover from "../assets/svg/sales-b.svg";
import cost_hover from "../assets/svg/cost-b.svg";
import DraggableDivider from './Jobs/DraggableDivider';
import CommonFooter from '../CommonFooter/CommonFooter';

const ContractViewPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const contract = state?.charges;
    const totalSales = state?.total_sales_amount;
    const totalCost = state?.total_cost_amount;
    const tableRefs = useRef({});

    const getTableRef = (categoryId, type) => {
        if (!tableRefs.current[categoryId]) {
            tableRefs.current[categoryId] = {
                sales: React.createRef(),
                cost: React.createRef()
            };
        }
        return tableRefs.current[categoryId][type];
    };
    const [viewModes, setViewModes] = useState({});

    // const formatJobTypePeriod = (period) => {
    //     if (!period) return "-";

    //     if (period.period_type === "monthly") {
    //         return `Every ${period.month_period} month${period.month_period > 1 ? "s" : ""
    //             } on day ${period.month_date} (starting from ${new Date(
    //                 period.month_start_date
    //             ).toLocaleDateString("en-GB", {
    //                 day: "2-digit",
    //                 month: "short",
    //                 year: "numeric",
    //             })})`;
    //     }
    //     return `${period.period_type || "-"}`;
    // };

    const [allCategories, setAllCategories] = useState([]);

    useEffect(() => {
        if (contract?.job_type) {
            const transformed = contract.job_type.map((job) => {
                // Calculate totals
                const salesNetTotal = job.chargelines.sales.reduce(
                    (sum, c) => sum + Number(c.net_total || 0),
                    0
                );
                const costNetTotal = job.chargelines.cost.reduce(
                    (sum, c) => sum + Number(c.net_total || 0),
                    0
                );
                const profitAmount = salesNetTotal - costNetTotal;
                const profitPercent =
                    salesNetTotal > 0
                        ? ((profitAmount / salesNetTotal) * 100).toFixed(2)
                        : 0;

                return {
                    id: job.job_type_id,
                    name: job.job_type_name,
                    salesRows: job.chargelines.sales.map(sale => ({
                        id: sale.contract_charge_line_table_id,
                        chargecode: sale.charge_name || "-",
                        charge_code: sale.charge_code || "-",
                        description: sale.description_of_charges || "-",
                        remarks: sale.remarks || "-",
                        po_wo_number: sale.po_wo_number || "-",
                        po_wo_date: sale.po_wo_date || "-",
                        quantity: sale.unit_of_quantity || "-",
                        rate: sale.unit_of_rate || "-",
                        netTotal: sale.net_total || "0"
                    })),
                    costRows: job.chargelines.cost.map(cost => ({
                        id: cost.contract_charge_line_table_id,
                        chargecode: cost.charge_name || "-",
                        charge_code: cost.charge_code || "-",
                        description: cost.description_of_charges || "-",
                        vendorName: cost.vendor_name || "-",
                        remarks: cost.remarks || "-",
                        po_wo_number: cost.po_wo_number || "-",
                        po_wo_date: cost.po_wo_date || "-",
                        quantity: cost.unit_of_quantity || "-",
                        rate: cost.unit_of_rate || "-",
                        netTotal: cost.net_total || "0"
                    })),
                    salesNetTotal,
                    costNetTotal,
                    profitAmount,
                    profitPercent,
                    jobTypePeriod: job.job_type_period,
                };
            });

            setAllCategories(transformed);
        }
    }, [contract]);

    const handleViewModeChange = (categoryId, mode) => {
        setViewModes(prev => ({
            ...prev,
            [categoryId]: mode
        }));
    };

    const getViewModeForCategory = (categoryId) => {
        return viewModes[categoryId] || "split";
    };


    return (
        <>
            <Contracts_header onSearch={null} disableSearch={true} />
            <div className="jobs-module-header">
                <div className="jobs-module-header-left">
                    <img
                        src={back_arrow}
                        alt="Back Arrow"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                    />
                    <p className="new_job" style={{ fontSize: '15px' }}>{contract?.contract_code || "Code No"}</p>
                </div>

            </div>

            <div className="jobs-module-details" >
                <div className="jobs-module-job-details">
                    <p className="jobs-module-jobs-details-header">Contract details</p>
                    <div className="jobs-module-details-grid">
                        <p className="jobs-module-jobs-details-label">Contract Code</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.contract_code}
                        </p>

                        <p className="jobs-module-jobs-details-label">Project</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.project_name}
                        </p>

                        <p className="jobs-module-jobs-details-label">Start Date</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.contract_start_date}
                        </p>

                        <p className="jobs-module-jobs-details-label">Expire Date</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.contract_expiry_date}
                        </p>

                        {/* <p className="jobs-module-jobs-details-label">Job Creation Period</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.job_type?.[0]?.job_type_period
                                ? formatJobTypePeriod(contract.job_type[0].job_type_period)
                                : "-"}
                        </p> */}

                        <p className="jobs-module-jobs-details-label">Mail Id</p>
                        <p className="jobs-module-jobs-details-value">
                            {contract?.contract_mail || "-"}
                        </p>

                        <p className="jobs-module-jobs-details-label">Total Sales Amount</p>
                        <p className="jobs-module-jobs-details-value">
                            {totalSales}
                        </p>

                        <p className="jobs-module-jobs-details-label">Total Cost Amount</p>
                        <p className="jobs-module-jobs-details-value">
                            {totalCost}
                        </p>
                    </div>
                </div>

                <div className="jobs-module-job-types">
                    <div className="job-types-content">
                        <p className="jobs-module-jobs-details-header">Job types</p>

                        <div className="job-types-buttons">
                            {contract?.job_type?.map((job) => (
                                <div key={job.job_type_id} className="job-type-card">
                                    <button className='jobs-module-jobs-details-data'>
                                        {job.job_type_name}
                                    </button>
                                </div>
                            )) || <p>No job types found</p>}
                        </div>
                    </div>
                </div>
            </div>

            <div className="contracts_popup_categories" >
                <label
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#333",
                        fontFamily: "Work Sans, sans-serif"
                    }}
                >
                    Job Types
                </label>

                {allCategories.map((category) => (
                    <div key={category.id} className="contracts_popup_outercategory">
                        <div
                            className="contracts_popup_category_header"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: "10px",
                                padding: "10px",
                                fontWeight: "bold",
                                fontSize: "16px",
                            }}
                        >
                            {/* Category Name */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span className="category_name" style={{ fontWeight: "bold", fontSize: "13px" }}>
                                    {category.name}
                                </span>
                                {/* 
                                {category.jobTypePeriod && (
                                    <span style={{ fontSize: "13px", color: "#666" }}>
                                        -Every {category.jobTypePeriod.month_period} month(s) on day{" "}
                                        {category.jobTypePeriod.month_date} (starting from{" "}
                                        {new Date(category.jobTypePeriod.month_start_date).toLocaleDateString(
                                            "en-GB",
                                            { day: "2-digit", month: "short", year: "numeric" }
                                        )}
                                        )
                                    </span>
                                )} */}
                            </div>

                            {/* Financial Boxes */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: "12px",
                                    fontSize: "12px",
                                    flexWrap: "wrap",
                                    flexGrow: 1,
                                    justifyContent: "flex-start",
                                    minWidth: "min-content",
                                }}
                            >
                                {/* SALES BOX */}
                                <div
                                    style={{
                                        backgroundColor: "#ffffff",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: "30px",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <span style={{ color: "green", fontWeight: "600" }}>SALES :</span>
                                    <span style={{ color: "#000" }}>
                                        Net total : ₹{category.salesNetTotal?.toLocaleString()}
                                    </span>
                                </div>

                                <div
                                    style={{
                                        width: "1px",
                                        backgroundColor: "#ccc",
                                        alignSelf: "stretch",
                                    }}
                                />

                                {/* COST BOX */}
                                <div
                                    style={{
                                        backgroundColor: "#ffffff",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: "30px",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <span style={{ color: "#007bff", fontWeight: "600" }}>COST :</span>
                                    <span style={{ color: "#000" }}>
                                        Net total : ₹{category.costNetTotal?.toLocaleString()}
                                    </span>
                                </div>

                                <div
                                    style={{
                                        width: "1px",
                                        backgroundColor: "#ccc",
                                        alignSelf: "stretch",
                                    }}
                                />

                                {/* PROFIT BOX */}
                                <div
                                    style={{
                                        backgroundColor: "#ffffff",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: "30px",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <span style={{ color: "purple", fontWeight: "600" }}>PROFIT :</span>
                                    <span style={{ color: "#000" }}>
                                        Amount : ₹{category.profitAmount?.toLocaleString()}
                                    </span>
                                    <span style={{ color: "purple", fontWeight: "600" }}>PROFIT % :</span>
                                    <span style={{ color: "#000" }}>{category.profitPercent}%</span>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="contracts_popup_category_subheader" >
                            <div className="contracts_popup_element_list" style={{ overflowX: "auto" }}>
                                <div style={{
                                    display: "flex",
                                    gap: "12px",
                                    fontSize: '12px',
                                    flexWrap: "wrap",
                                    flexGrow: 1,
                                    justifyContent: "flex-start",
                                    minWidth: "min-content",
                                    padding: '10px',
                                    cursor: 'pointer',
                                    fontWeight: '600'
                                }}>
                                    <div onClick={() => handleViewModeChange(category.id, "split")} style={{
                                        backgroundColor: getViewModeForCategory(category.id) === "split" ? "#D0E6FF" : "#EDF3F9",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: '30px',
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        flexShrink: 0,
                                        color: getViewModeForCategory(category.id) === "split" ? "#007bff" : "",
                                        transition: "all 0.3s ease",
                                    }}>
                                        <img src={getViewModeForCategory(category.id) === "split" ? split_hover : split} alt="Split View" />
                                        <span style={{ transition: "color 0.3s ease" }}>Split View</span>
                                    </div>
                                    <div style={{
                                        width: "1px",
                                        backgroundColor: "#ccc",
                                        alignSelf: "stretch",
                                        flexShrink: 0
                                    }} />
                                    <div onClick={() => handleViewModeChange(category.id, "sales")} style={{
                                        backgroundColor: getViewModeForCategory(category.id) === "sales" ? "#D0E6FF" : "#EDF3F9",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: '30px',
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        flexShrink: 0,
                                        color: getViewModeForCategory(category.id) === "sales" ? "#007bff" : "",
                                        transition: "all 0.3s ease",
                                    }}>
                                        <img src={getViewModeForCategory(category.id) === "sales" ? cost_hover : cost} alt="Sales View" />
                                        <span style={{ transition: "color 0.3s ease" }}>Sales View</span>
                                    </div>
                                    <div style={{
                                        width: "1px",
                                        backgroundColor: "#ccc",
                                        alignSelf: "stretch",
                                        flexShrink: 0
                                    }} />
                                    <div onClick={() => handleViewModeChange(category.id, "cost")} style={{
                                        backgroundColor: getViewModeForCategory(category.id) === "cost" ? "#D0E6FF" : "#EDF3F9",
                                        borderRadius: "10px",
                                        padding: "12px 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        height: '30px',
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        flexShrink: 0,
                                        color: getViewModeForCategory(category.id) === "cost" ? "#007bff" : "",
                                        transition: "all 0.3s ease",
                                    }}>
                                        <img src={getViewModeForCategory(category.id) === "cost" ? sales_hover : sales} alt="Sales View" />
                                        <span style={{ transition: "color 0.3s ease" }}>Cost View</span>
                                    </div>
                                </div>

                                <div className="tables-wrapper">
                                    {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "sales") && (
                                        <div className="table-container sales-table" ref={getTableRef(category.id, "sales")} style={{
                                            position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "0 0 50%" : "1 1 100%",
                                            width: getViewModeForCategory(category.id) === "split" ? "50%" : "100%", transition: 'flex 0.2s ease',
                                            display: getViewModeForCategory(category.id) === "split" ? "block" :
                                                (getViewModeForCategory(category.id) === "sales" ? "block" : "none")
                                        }}>
                                            <table className="invoice_table" >
                                                <thead>
                                                    <tr>
                                                        <th colSpan="8" style={{ backgroundColor: "#D9FFE2", color: "#008B1F", padding: '7px' }}>
                                                            SALES
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>CHARGE CODE</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>DESCRIPTION</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>PO WO NUMBER</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>PO WO DATE</th>
                                                        <th style={{ backgroundColor: "#D9FFE2", padding: '10px' }}>REMARKS</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>QUANTITY</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>RATE</th>
                                                        <th style={{ backgroundColor: "#D9FFE2" }}>NET TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {category.salesRows.map((row) => (
                                                        <tr key={row.id}>
                                                            <td style={{ padding: '12px' }}>{row.charge_code}</td>
                                                            <td>{row.description}</td>
                                                            <td>{row.po_wo_number}</td>
                                                            <td>{row.po_wo_date}</td>
                                                            <td>{row.remarks}</td>
                                                            <td>{row.quantity}</td>
                                                            <td>{row.rate}</td>
                                                            <td>{row.netTotal}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    {(getViewModeForCategory(category.id) === "split") && <DraggableDivider leftRef={getTableRef(category.id, "sales")}
                                        rightRef={getTableRef(category.id, "cost")} />}

                                    {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "cost") && (
                                        <div className="table-container cost-table" ref={getTableRef(category.id, "cost")} style={{
                                            position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "1 1 0px" : "1 1 100%",
                                            width: getViewModeForCategory(category.id) === "split" ? "auto" : "100%", transition: 'flex 0.2s ease',
                                            display: getViewModeForCategory(category.id) === "split" ? "block" :
                                                (getViewModeForCategory(category.id) === "cost" ? "block" : "none")
                                        }}>
                                            <table className="invoice_table" >
                                                <thead>
                                                    <tr>
                                                        <th colSpan="9" style={{ backgroundColor: "#E0EFFF", color: "#097BED", padding: '7px' }}>
                                                            COST
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>CHARGE CODE</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>DESCRIPTION</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>VENDOR</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>PO WO NUMBER</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>PO WO DATE</th>
                                                        <th style={{ backgroundColor: "#E0EFFF", padding: '10px' }}>REMARKS</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>QUANTITY</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>RATE</th>
                                                        <th style={{ backgroundColor: "#E0EFFF" }}>NET TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {category.costRows.map((row) => (
                                                        <tr key={row.id}>
                                                            <td style={{ padding: '12px' }}>{row.charge_code}</td>
                                                            <td>{row.description}</td>
                                                            <td>{row.vendorName}</td>
                                                            <td>{row.po_wo_number}</td>
                                                            <td>{row.po_wo_date}</td>
                                                            <td>{row.remarks}</td>
                                                            <td>{row.quantity}</td>
                                                            <td>{row.rate}</td>
                                                            <td>{row.netTotal}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <CommonFooter />
        </>
    );
};

export default ContractViewPage;
